import { all } from 'redux-saga/effects';
import * as albums from './album';
import * as photos from './photos';

export function* sagas() {
    yield all([
        albums.sagas(),
        photos.sagas()
    ]);
};